export const SOCKET_CONNECTION_IN_PROGRESS = 'SOCKET_CONNECTION_IN_PROGRESS';
export const SOCKET_CONNECTION_SUCCESS = 'SOCKET_CONNECTION_SUCCESS';
export const SOCKET_CONNECTION_ERROR = 'SOCKET_CONNECTION_ERROR';
export const SOCKET_RECONNECTION_ERROR = 'SOCKET_RECONNECTION_ERROR';
export const SOCKET_CONNECTION_CLOSE = 'SOCKET_CONNECTION_CLOSE';
export const SET_MEDIA_NODE_PAGE_ACTIVE = 'SET_MEDIA_NODE_PAGE_ACTIVE';
export const MEDIA_NODE_LIVE_STREAM_ENDED_SET = 'MEDIA_NODE_LIVE_STREAM_ENDED_SET';
export const MEDIA_NODE_LIVE_STREAM_STARTED_SET = 'MEDIA_NODE_LIVE_STREAM_STARTED_SET';
export const MEDIA_NODE_LIVE_STREAM_FIRST_CONNECTION_SET = 'MEDIA_NODE_LIVE_STREAM_FIRST_CONNECTION_SET';
export const RECONNECT_MAX_TIME = 60000;
export const RECONNECT_INTERVAL_TIME = 10000;
export const TIMER_SET = 'TIMER_SET';

export const SOCKET_LIVE_STREAM_CONNECTION_IN_PROGRESS = 'SOCKET_LIVE_STREAM_CONNECTION_IN_PROGRESS';
export const SOCKET_LIVE_STREAM_CONNECTION_SUCCESS = 'SOCKET_LIVE_STREAM_CONNECTION_SUCCESS';
export const SOCKET_LIVE_STREAM_CONNECTION_ERROR = 'SOCKET_LIVE_STREAM_CONNECTION_ERROR';
export const SOCKET_LIVE_STREAM_RECONNECTION_ERROR = 'SOCKET_LIVE_STREAM_RECONNECTION_ERROR';
export const SOCKET_LIVE_STREAM_CONNECTION_CLOSE = 'SOCKET_LIVE_STREAM_CONNECTION_CLOSE';
export const SET_LIVE_STREAM_CONNECTION_ACTIVE = 'SET_LIVE_STREAM_CONNECTION_ACTIVE';

export const SOCKET_ASSET_ENCODING_CONNECTION_IN_PROGRESS = 'SOCKET_ASSET_ENCODING_CONNECTION_IN_PROGRESS';
export const SOCKET_ASSET_ENCODING_CONNECTION_SUCCESS = 'SOCKET_ASSET_ENCODING_CONNECTION_SUCCESS';
export const SOCKET_ASSET_ENCODING_CONNECTION_ERROR = 'SOCKET_ASSET_ENCODING_CONNECTION_ERROR';
export const SOCKET_ASSET_ENCODING_RECONNECTION_ERROR = 'SOCKET_ASSET_ENCODING_RECONNECTION_ERROR';
export const SOCKET_ASSET_ENCODING_CONNECTION_CLOSE = 'SOCKET_ASSET_ENCODING_CONNECTION_CLOSE';
export const SET_ASSET_ENCODING_CONNECTION_ACTIVE = 'SET_ASSET_ENCODING_CONNECTION_ACTIVE';
export const ASSET_ENCODING_PERCENTAGE_SET = 'ASSET_ENCODING_PERCENTAGE_SET';
